import { Component, OnInit, HostListener, Input, Output, EventEmitter } from '@angular/core';
import { Storage } from '@ionic/storage';
import { TranslateService } from '../../shared/translate/services/translate.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoginConfig } from './shared/login-config.model';
import { EMAIL_REGEX } from '../../shared/regular-expressions/regex';
import { AlertController } from '@ionic/angular';
import { TranslatePipe } from '../../shared/translate/pipes/translate.pipe';

@Component({
  selector: 'inc-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  imgError = false;
  loginForm: FormGroup;
  selectedLanguage: string;


  @Input() alertMessage: string;

  @Input() loginConfig: LoginConfig = {
    title: 'INCLOUDED',
    version: '',
    versionLink: ''
  };

  @Output() callLogin = new EventEmitter<{ email: string, password: string, isRememberMe: boolean }>();
  @Output() callPasswordReminder: EventEmitter<string> = new EventEmitter<string>();

  @HostListener('document:keydown.enter') onKeydownHandler() {
    this.login();
  }

  constructor(
    public storage: Storage,
    private translateService: TranslateService,
    private alertController: AlertController,
    private translate: TranslatePipe
  ) { }

  ngOnInit() {
    this.selectedLanguage = this.translateService.selectedLanguage;
    this.initLoginForm();

    this.storage.remove('user');
    this.storage.remove('role');
    this.storage.get('isRememberMe').then((result) => {
      this.loginForm.controls.isRememberMe.setValue(result);
    });
  }

  initLoginForm() {
    this.loginForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern(EMAIL_REGEX)]),
      password: new FormControl('', Validators.required),
      isRememberMe: new FormControl(false)
    });
  }

  isRememberMeChange(event: any) {
    this.storage.remove('isRememberMe');
    if (event.detail.checked) {
      this.storage.set('isRememberMe', true);
    }
  }

  changeLanguage(event: any): void {
    this.selectedLanguage = event.detail.value;
    this.translateService.use(this.selectedLanguage);
  }

  onImgError(event) {
    if (event) {
      this.imgError = true;
    }
  }

  login() {
    if (this.loginForm.invalid) { return; }
    this.callLogin.emit(this.loginForm.value);
  }

  async passwordReminder() {
    const alert = await this.alertController.create({
      header: this.translate.transform('PReminder'),
      message: this.translate.transform('PReminderMessage'),
      inputs: [
        {
          name: 'email',
          type: 'text',
          placeholder: 'email'
        }
      ],
      buttons: [
        {
          text: this.translate.transform('CANCEL_BUTTON'),
          role: 'cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: this.translate.transform('SEND'),
          handler: data => {
            this.callPasswordReminder.emit(data.email);
          }
        }
      ]
    });
    await alert.present();
  }
}
